import { Box, Button, Icon, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { SignedInvoice } from './types'

export const Actions = ({ signedInvoice }: { signedInvoice: SignedInvoice }) => {
  const { navigation } = useNavigation()
  const [open, toggle] = useToggle(false)
  const [mandatoryToggleOpen, setMandatoryToggleOpen] = useToggle(false)

  return (
    <Box flexDirection="row" justifyContent="flexEnd" alignItems="center" gap="s24">
      <Box flexDirection="row">
        {!!signedInvoice.missingRequiredData && (
          <Tooltip.Alt
            attachment="bottom center"
            toggle={setMandatoryToggleOpen}
            open={mandatoryToggleOpen}
            label={i18n.t('expenses.settings.signed_invoices.list.table.missingMandatoryFields')}
          >
            <Icon.Medium icon="info-circle-line" color="grey800" />
          </Tooltip.Alt>
        )}
        {!!signedInvoice.beenTampered && (
          <Tooltip.Alt
            attachment="bottom center"
            toggle={toggle}
            open={open}
            label={i18n.t('expenses.settings.signed_invoices.list.table.documentModified')}
          >
            <Icon.Medium icon="info-circle-line" color="grey800" />
          </Tooltip.Alt>
        )}
      </Box>
      <Button.Router
        to={navigation.settings.expenses.signedInvoices.invoiceId.fullPath({
          invoiceId: signedInvoice.id,
        })}
        type="secondary"
        iconName="arrow-right"
      />
    </Box>
  )
}
